"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGroupBySingleFieldPointerMethod = void 0;
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
// This method is not required anymore. You should instead
// use declaritive config with
// type: 'exposureByGroup';
const makeGroupBySingleFieldPointerMethod = ({ field, method, type, exclusion, }) => {
    return {
        method,
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit ${method}`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            concentrationReceivables.forEach((rec) => {
                (0, common_1.finleyAssert)(typeof rec.baseFields[field] === type, `baseFields.${field} must be defined to run ${method}. Found [${rec.baseFields[field]}}]`);
            });
            const grouped = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields[field]);
            if (exclusion) {
                // Order grouped field names in descending order by sum of exposure
                const topFields = lodash_1.default.sortBy(Object.keys(grouped), (groupedField) => lodash_1.default.sumBy(grouped[groupedField], (receivable) => receivable.concentrationLimitFields
                    .eligibleExposureLessConcentrationLimitKickouts)).reverse();
                // Remove field for top N groups as specified by exclusion option
                topFields
                    .slice(0, exclusion.largestNumberOfGroups)
                    .forEach((groupedField) => {
                    delete grouped[groupedField];
                });
            }
            const standardBorrowingBaseReductions = lodash_1.default.map(lodash_1.default.values(grouped), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        // eslint-disable-next-line no-param-reassign
                        result[finleyReceivableId] = 0;
                    }
                    // eslint-disable-next-line no-param-reassign
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    };
};
exports.makeGroupBySingleFieldPointerMethod = makeGroupBySingleFieldPointerMethod;
//# sourceMappingURL=makeGroupBySingleFieldPointerMethod.js.map